const t = "toast-notification";
export {
  t as TOAST_CLASS_NAME
};
//# sourceMappingURL=toast-class-name.js.map
